export default __webpack_public_path__ + "static/media/icon_calories.9d1ad7e6.svg";